import type { NoContext } from '~/services/api/contracts/NoContext'
import { DashboardUsersQuerySchema } from '~/services/api/generated'

// Dashboard\PaginationRequest::rules
export const DashboardUsers = (_context: NoContext = {}) => DashboardUsersQuerySchema
